import {
	Vue, Component, Ref, toNative,
} from 'vue-facing-decorator';
import EditBulkDiscountTable from 'components/Discounts/BulkDiscount/EditBulkDiscountTable';
import { useRoute } from 'vue-router';
import Template from './template.vue';

@Component({
	components: {
		EditBulkDiscountTable,
	},
	mixins: [Template],
})
class EditBulkDiscount extends Vue {
	private route = useRoute();

	@Ref('editbulkdiscount')
	public readonly editproduct!: HTMLFormElement;

	private bulkDiscountId = this.route.params.id;

	protected updateBulkDiscountProperties(): void {
		this.editproduct.editSingleBulkDiscount();
	}
}

export default toNative(EditBulkDiscount);
